import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

declare var bootstrap: any;

@Component({
  selector: 'app-safetyzones-workers',
  templateUrl: './safetyzones-workers.component.html',
  styleUrls: ['./safetyzones-workers.component.scss']
})
export class SafetyzonesWorkersComponent implements OnInit {


  safety_zones: any;
  safety_zone: any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getSafetyZones();

  }

  getSafetyZones(){


    this.okService.get("safetyzones",{expand:'summary'})
    .subscribe((data) => {

      this.safety_zones = data.body;


      //console.log(this.safety_zones);

    });

  }

  viewWorkers(safety_zone:any){



    this.safety_zone = safety_zone;

    var myModal = new bootstrap.Modal(document.getElementById('summaryModal'));
    myModal.show();

  }

}
